import React,{useReducer, createContext} from "react";
import contextReducer from './contextReducer';
const initialState = JSON.parse(localStorage.getItem('transactions'))||[{"amount":20,"category":"Food","type":"Expense","date":"2023-02-07","id":"7bc85ba8-ebd2-48d7-b50c-b03809995ee4"},{"amount":100,"category":"Salary","type":"Income","date":"2023-02-06","id":"2efaa858-3664-4db0-a847-a3bd45539bae"}];

export const ExpenseTrackerContext = createContext(initialState);
export const Provider = ({children})=>{
    const [transactions,dispatch] = useReducer(contextReducer,initialState);
    const deleteTransaction = (id)=>dispatch({type:'DELETE_TRANSACTION', payload: id});
    const addTransaction = (transaction)=>dispatch({type:'ADD_TRANSACTION', payload:transaction});
    const Balance = transactions.reduce((acc,currVal)=>{
        return (currVal.type==='Expense' ? acc-currVal.amount:acc+currVal.amount);
    },0)
    console.log(transactions);
    return (
        <ExpenseTrackerContext.Provider value = {{
            deleteTransaction,
            addTransaction,
            transactions,
            Balance
            }}>
            {children}
        </ExpenseTrackerContext.Provider>
    )
}
